// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import {isLink} from '../../../shared/services/product-search-helper';

const ProductSearchResultAction = props => {

    if (isLink(props.statusList, props.label)) {

        return (
            <Link
                to={props.link}
            >
                <FormattedMessage id={props.label}/>
            </Link>
        );

    }

    return (
        <span
            className='disabled-link'
        >
            <FormattedMessage id={props.label}/>
        </span>
    );

};

ProductSearchResultAction.displayName = 'ProductSearchResultAction';
ProductSearchResultAction.propTypes = {
    label: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    statusList: PropTypes.array.isRequired
};

export default ProductSearchResultAction;



// WEBPACK FOOTER //
// ./src/product/search/components/product-search-popover/product-search-action.js